<template>
  <b-row align-h="center">
    <b-col cols="12">
      <MediaViewer @route-update="updateRoute" :targetPath="path" :view="'grid'"/>
    </b-col>
  </b-row>
</template>

<script>
import mediaMixin from './mediaMixin';
import MediaViewer from '@/components/MediaViewer.vue';


export default {
  mixins: [mediaMixin],
  components: { MediaViewer },
  props: {
    path: {
      type: [String, Number],
      required: false,
    },
  },
  watch: {
    path: {
      required: true,
      handler(newPath) {
        this.path = newPath;
      },
    },
  },
  methods: {
    updateRoute(newRoute) {
      this.$router.push(newRoute);
    },
  },
};
</script>
